/* ---------------------------------------------
 NAV MENU
 --------------------------------------------- */

export function init() {
    jQuery(".searchbtn").on("click", function (e) {
        e.preventDefault();
        if (jQuery("#searchform").hasClass("active")) {
            jQuery("#searchform").submit();
        } else {
            jQuery("#searchform").addClass("active");
        }
    })

    jQuery(".grid-list li").remove();
    jQuery("<li class='filterstoggle'></li>").appendTo(".grid-list");
    jQuery(".grid-list").on("click", ".filterstoggle", function () {
        jQuery(".filters").toggleClass("open");
        jQuery(".filterstoggle").toggleClass("open");
    })

    jQuery(".hamburger").on("click", function (e) {
        jQuery("body").toggleClass("navopen");
    });

    // jQuery(".haspopup input").on("click", function () {
    //     jQuery(this).closest(".haspopup").addClass("forceactive")
    // });

    jQuery(".top-icons").on("mouseover", ".haspopup", function () {
        jQuery(this).addClass("active")
    });

    jQuery(".top-icons").on("mouseout", ".haspopup", function () {
        console.log("mouseout haspopup");
        var hidepopup = true;

        jQuery(this).find("input").each(function () {
            // check for if has focus to avoid password manager glitch
            if (jQuery(this).is(":focus")) {
                hidepopup = false;
            }
        })
        if (hidepopup) {
            jQuery(this).removeClass("active")
        }



    });

    jQuery(".menu-item-has-children").on("click", ".icon-chevron", function (e) {
        if (jQuery("body").hasClass("navopen")) {
            e.stopPropagation();
            e.preventDefault();
            // alert("clicked")
            var thisopen = jQuery(this).parent(".menu-item-has-children").hasClass("open") ? true : false;

            jQuery(this).parent(".menu-item-has-children").removeClass("open");

            if (!thisopen) {
                jQuery(this).parent(".menu-item-has-children").addClass("open");
            }

        }
    });

    jQuery("#nav >.wp-block-group").on("click", function (e) {

        jQuery("#nav").find("img").each(function () {
            if (jQuery(this).attr("data-src") != "") {
                jQuery(this).attr("src", jQuery(this).attr("data-src"));
                jQuery(this).attr("srcset", jQuery(this).attr("data-srcset"));
                jQuery(this).attr("data-src", "");
            }
        })

        if (jQuery("body").hasClass("navopen")) {
            e.stopPropagation();
            var thisopen = jQuery(this).hasClass("open") ? true : false;

            jQuery("#nav >.wp-block-group").removeClass("open");

            if (!thisopen) {
                jQuery(this).addClass("open");
            }

        }
    })

    window.onscroll = function () { doStickyHeader() };

    function doStickyHeader() {
        if (jQuery(window).scrollTop() > 50) {
            jQuery("body >header").addClass("sticky-header");

        } else {
            jQuery("body > header").removeClass("sticky-header");
        }
    }
}

